var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecentOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 23,
    viewBox: "0 0 19 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3983 0.942773L16.3114 5.73696C16.3907 5.93602 16.4365 6.1164 16.469 6.32954L18.9838 21.211C19.1016 21.9089 18.5611 22.5445 17.8528 22.5406L12.5191 22.5135C12.4412 22.5142 12.3742 22.467 12.3464 22.3909C12.3182 22.3148 12.3368 22.2323 12.395 22.1781C12.682 21.9103 12.8639 21.52 12.8678 21.0866L13 6.3919L14.0496 0.978708C14.0658 0.894507 14.13 0.83391 14.2115 0.825807C14.2929 0.817352 14.3669 0.863504 14.3983 0.942773ZM7.73477 3.20458H10.4104C10.7013 3.20458 10.94 2.9548 10.94 2.6497V2.12758C10.94 1.82284 10.7013 1.5727 10.4104 1.5727H7.73477H5.05877C4.7679 1.5727 4.52921 1.82284 4.52921 2.12758V2.6497C4.52921 2.9548 4.7679 3.20458 5.05877 3.20458H7.73477ZM7.73477 0H12.835C13.0705 0 13.3096 0.207156 13.2627 0.447782L12.0996 6.3919L11.967 21.0866C11.96 21.8909 11.3391 22.5476 10.5719 22.5476H1.40122C0.633322 22.5476 -0.0732258 21.8871 0.00610221 21.0866L1.43894 6.60751L3.41967 0.447782C3.44859 0.203281 3.61182 0 3.84699 0H7.73477Z",
    fill: "#3159A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecentOrder);
export default __webpack_public_path__ + "static/media/RecentOrder.ba6cd7065383eb4a65f5f5d9c78cdc39.svg";
export { ForwardRef as ReactComponent };